import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { API, authHdr } from "./AssociateFields";

// /sub-brokers/create → creates the "Associate Creation Pending" record, then opens Step 1.
export default function AssociateCreate() {
  const nav = useNavigate();
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    axios.post(`${API}/associates/draft`, {}, { headers: authHdr() })
      .then((r) => nav(`/sub-brokers/associate/${r.data.id}?mode=edit`, { replace: true }))
      .catch((e) => { toast.error(e.response?.data?.detail || "Could not start"); nav("/sub-brokers/list"); });
  }, [nav]);
  return <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin" /></div>;
}
